import { FC } from "react";
import TableBody from "./TableBody/TableBody";
import styles from "./OkvedTable.module.sass";

const OkvedTable: FC<{ outline: (id: string, isMain: boolean) => string }> = ({ outline }) => {
	return (
		<div className={styles.table}>
			<div className={styles.headerColumn}>
				<div />
				<div />
				<div>Код раздела или группы</div>
				<div>Наименование раздела/группы ОКВЭД</div>
				<div>Описание</div>
			</div>
			<TableBody outline={outline} />
		</div>
	);
};

export default OkvedTable;
